const titulos={
    VentanaCrear:"Detalles de Cliente",
}

const notificaciones={
    creacion:"Cliente Creado",
    modificacion:"Cliente Modificado",
    eliminacion:"Cliente Desactivado",
}

export {titulos,notificaciones}